module.exports = __webpack_public_path__ + "media/images/crypto-currencies/ripple-7220f1cf20f021586b3cdcb5038156ff.svg";